let routes = [
    {
      path: '/demande-dispense-formation',
      component: () => import('../views/DemandeDispenseFormation.vue'),
      props: true
    },
    {
      path: '/demande-dispense-formation/:step',
      component: () => import('../views/DemandeDispenseFormation.vue'),
      props: true
    }
  ]
  
  export default routes;